import { Check, DriveFileRenameOutline } from '@mui/icons-material'
import { Button, ButtonProps } from '@mui/material'
import React, { FC } from 'react'

interface EditButtonProps extends ButtonProps {
    editOn: boolean
}

export const EditButton: FC<EditButtonProps> = (props: EditButtonProps) => {
    const { editOn, ...buttonProps } = props
    return (
        <Button
            variant="text"
            {...buttonProps}
            startIcon={editOn ? <Check /> : <DriveFileRenameOutline />}
        >
            <div style={{ textDecoration: 'underline' }}>
                {editOn ? 'Save' : 'Edit'}
            </div>
        </Button>
    )
}
